<template>
    <div class="chat d-flex flex-column me-md-5">
        <div v-for="(m, index) in messages" :class="'row w-100 ' + (m.inbound ? 'inbound' : 'outbound') + (m.ai ? ' ai' : '')" :key="m.id">
            <div class="col-sm-2 my-1 p-0 small text-end text-muted text-nowrap">{{ Formatters.localTimeSeconds(m.updatedAt) }}</div>
            <div class="col-sm-10">
                <div :class="'my-1 ' + (m.state == 6 ? 'text-center' : 'message')">
                    <div v-html="m.translation || m.text"></div>
                    <div v-if="m.translation" class="translation" v-html="m.text" title="Translation"></div>
                    <div v-if="m.attachment !== null">
                        <a class="btn btn-outline-primary p-0 overflow-hidden" :href="m.attachment.url" target="_blank">
                            <img :src="m.attachment.thumb" class="img-fluid" />
                        </a>
                    </div>
                    <div v-if="index === 0 && m.keywords?.length" class="d-block my-1">
                        <span v-for="k in m.keywords" :key="k" class="btn btn-sm btn-outline-primary me-1 mt-1" v-html="k"></span>
                    </div>
                    <a v-if="m.ai" href="" class="btn btn-link" title="Add training"
                       @click.prevent="retrainMessage(messages[index-1], m)"><i class="fa fa-robot text-primary"></i></a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Formatters } from '../common/formatters';

    export default {
        props: ['messages'],
        emits: ['retrain'],
        data: function () {
            return {
                Formatters,
            };
        },
        methods: {
            retrainMessage(prompt, response) {
                this.$emit('retrain', prompt, response);
            }
        }
    }
</script>